import React, { type FC } from 'react';

import type { DropdownOption } from 'src/common/components/DropdownDS22';
import type { ImmutableTrip } from 'src/types/trips/Trips';
import type { Location } from 'history';
import {
  CaptainCard,
  CommentCard,
  DatesCard,
  DurationCard,
  GroupSizeCard,
  TimeCard,
  VesselCard,
} from '../../cards';
import CTA, { CTALink } from '../../CTA';
import TripPanel from '../../presentation/TripPanel';
import TripDetailsTitle from '../../presentation/TripDetailsTitle';
import { getMessage } from '../content';
import TopScroll from '../../../../common/components/TopScroll';
import { PATHS } from '../../../../common/constants';
import { appendRoute, preserveSearch } from '../../../../common/utils/routing';
import { CAPTAINED_FIELD, PAGES } from '../../../constants';
import TripMenu from '../../TripMenu';

type OwnerChangesRequestedType = {
  cancellationDropdownOptions: DropdownOption[];
  trip: ImmutableTrip;
  location: Location;
};

const OwnerChangesRequested: FC<OwnerChangesRequestedType> = ({
  cancellationDropdownOptions,
  trip,
  location,
}) => (
  <TripPanel
    cta={(
      <CTA classNameModifier="withSidebar">
        <TripMenu
          cancellationDropdownOptions={cancellationDropdownOptions}
          trip={trip}
        />
        <CTALink to={preserveSearch(appendRoute(location.pathname, PAGES.PRICE), location)}>
          Update Offer
        </CTALink>
      </CTA>
    )}
    trip={trip}
    subheader={trip.getIn(['state', 'badge'])}
    intro={getMessage(trip, location)}
    backLocation={preserveSearch(PATHS.INBOX, location)}
    classNameModifier="withoutSideMargins"
  >
    <TopScroll />
    <TripDetailsTitle />
    <VesselCard
      // TODO: see if there's another way of approaching the concept
      // of checkTripModification
      checkTripModification
      trip={trip}
    />
    <DatesCard
      requestedChanges
      checkTripModification
      trip={trip}
    />
    <TimeCard
      requestedChanges
      checkTripModification
      trip={trip}
    />
    <DurationCard
      requestedChanges
      checkTripModification
      trip={trip}
    />
    <GroupSizeCard
      requestedChanges
      checkTripModification
      trip={trip}
    />
    {trip.get(CAPTAINED_FIELD) !== null && (
      <CaptainCard
        checkTripModification
        trip={trip}
      />
    )}
    <CommentCard
      checkTripModification
      trip={trip}
    />
  </TripPanel>
);

export default OwnerChangesRequested;
